import qs from 'qs'
import Bus from '@/utils/bus'

const parenHasDataName = (dom: HTMLElement) => {
  const parent = dom.parentElement
  const dataName = parent?.getAttribute('data-name')
  if (!isEmpty(dataName)) {
    Bus.$emit('requestAnswer', dataName)
    return true
  }

  return false
}

export const getObjType = (obj: any) => {
  const type = Object.prototype.toString.call(obj)
  const array = type.split(/\s/g)
  return array[1].replace(']', '')
}

// 判断是否为空
export const isEmpty = (obj: any) => {
  const type = getObjType(obj)
  let flag = false
  switch (type) {
    case 'Null':
      flag = true
      break
    case 'Undefined':
      flag = true
      break
    case 'String':
      if (obj.trim() === '') {
        flag = true
      }
      break
    case 'Array':
      if (obj.length === 0) {
        flag = true
      }
      break
    default:
      flag = false
  }
  return flag
}

const parsePath = (path: string) => {
  const segments = path.split('.')
  return function (obj: any) {
    for (let i = 0; i < segments.length; i++) {
      if (!obj) return
      obj = obj[segments[i]]
    }
    return obj
  }
}

/**
 * 获取属性值
 * @param target
 * @param path
 * @param defaultVal
 * @returns
 */
export const getVal = (target: Object, path: string, defaultVal:any = '') => {
  const val = parsePath(path)(target)
  if (val === undefined || val === null) {
    return defaultVal
  }

  return val
}

export const getUrlParam = (key:string) => {
  const search = window.location.search
  if (isEmpty(search)) {
    return null
  } else {
    const str = search.slice(1)
    const json = qs.parse(str)
    return json[key]
  }
}

/**
 * 格式化json
 * @param obj
 * @param defaultValue
 * @returns
 */
export const parseJson = (obj:string, defaultValue : any = '') => {
  try {
    if (isEmpty(obj)) {
      return defaultValue
    }
    obj = JSON.parse(obj)
    const type = getObjType(obj)
    if (type === 'String') {
      obj = JSON.parse(obj)
    }
  } catch (error) {
    return defaultValue
  }
  return obj
}

export const getUserMedia = (constraints: MediaStreamConstraints) => {
  const navigator: Navigator = window.navigator
  return navigator.mediaDevices.getUserMedia(constraints)
}

export const deviceVibrate = (time: number) => {
  const navigator: any = window.navigator
  if (navigator.vibrate) {
    navigator.vibrate(time)
  } else if (navigator.webkitVibrate) {
    navigator.webkitVibrate(time)
  } else if (navigator.mozVibrate) {
    navigator.mozVibrate(time)
  } else if (navigator.msVibrate) {
    navigator.msVibrate(time)
  }
}


export const htmlClick = (e: Event, vm: any) => {
  e.preventDefault()
  const target = e.target
  if (!target) {
    return
  }

  const tagName = (target as HTMLElement).tagName.toLowerCase()
  switch (tagName) {
    // 图片预览
    case 'img':
      const src = (target as HTMLImageElement).src
      src && vm.$emit('previewImg', src)
      break
    // 富文本意图
    case 'span':
      const dataName = (target as HTMLSpanElement).getAttribute('data-name')
      dataName && Bus.$emit('requestAnswer', dataName)
      break
    case 'a':
      // 判断是否父元素span有data-name
      if (parenHasDataName(target as HTMLElement)) {
        return
      }

      const href = (target as HTMLAnchorElement).href
      if (href) {
        // TODO
        // 判断环境
        // 小程序
        let url = null
        try {
          url = new URL(href)
        } catch (error) {}

        if (url) {
          window.open(href)
        }
      }
      break
    default:
      break
  }

}

/**
 * 用浏览器内部转换器实现html编码（转义)
 * @param html 
 * @returns 
 */
export const htmlEncode = (html: any) => {
  let temp: HTMLDivElement | null = document.createElement('div');
  (temp.textContent !== undefined) ? (temp.textContent = html) : (temp.innerText = html)

  const output = temp.innerHTML
  temp = null

  return output
}

/**
 * 用浏览器内部转换器实现html解码（反转义）
 * @param text 
 */
export const htmlDecode = (text: string) => {
  if (isEmpty(text)) {
    return ''
  }

  if (text.indexOf('&lt;') > -1) {
    let temp: HTMLDivElement | null = document.createElement('div')
    temp.innerHTML = text
    var output = temp.innerText || temp.textContent
    temp = null
    return output
  } else {
    return text
  }
}

export const getFileName = (path: string) => {
  const array = path.split('/')
  return array[array.length - 1]
}

export const dataURLToBlob = (base64Str: string) => {
  let bstr = window.atob(base64Str)
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { 'type' : 'audio/wav' })
}